var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
var Container = styled.div.attrs({
    role: 'link',
}).withConfig({ displayName: "Container", componentId: "sc-1ivguwl" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 8px 16px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: ", ";\n  white-space: nowrap;\n  &:hover,\n  &:focus {\n    cursor: pointer;\n    outline: 'none';\n  }\n"], ["\n  padding: 8px 16px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: ", ";\n  white-space: nowrap;\n  &:hover,\n  &:focus {\n    cursor: pointer;\n    outline: 'none';\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
var ButtonLink = function (_a) {
    var children = _a.children, onClick = _a.onClick, rest = __rest(_a, ["children", "onClick"]);
    return (_jsx(Container, __assign({ onClick: onClick }, rest, { children: children }), void 0));
};
export { ButtonLink };
var templateObject_1;
